import { render, staticRenderFns } from "./Privacy1.vue?vue&type=template&id=472da191&scoped=true&"
import script from "./Privacy1.vue?vue&type=script&lang=js&"
export * from "./Privacy1.vue?vue&type=script&lang=js&"
import style0 from "./Privacy1.vue?vue&type=style&index=0&id=472da191&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472da191",
  null
  
)

export default component.exports